import { ASSISTED_STYLE_ID } from "./constants";

const ASSISTED_CSS = `
  .redacto-assisted-phone-field:focus-within {
    border-color: var(--ra-accent, #4f87ff) !important;
    box-shadow: 0 0 0 3px var(--ra-accent-soft, rgba(79, 135, 255, 0.18)) !important;
  }
  .redacto-assisted-phone-input {
    border: none !important;
    outline: none !important;
    background: transparent !important;
    flex: 1 1 auto !important;
    min-width: 0 !important;
    font: inherit !important;
    font-size: 15px !important;
    color: #101828 !important;
    padding: 0 !important;
  }
  .redacto-assisted-otp-input {
    width: 42px !important;
    height: 46px !important;
    text-align: center !important;
    font: inherit !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    border: 1px solid #d0d5dd !important;
    border-radius: 8px !important;
    box-sizing: border-box !important;
    outline: none !important;
  }
  .redacto-assisted-otp-input:focus {
    border-color: var(--ra-accent, #4f87ff) !important;
    box-shadow: 0 0 0 3px var(--ra-accent-soft, rgba(79, 135, 255, 0.18)) !important;
  }
  .redacto-assisted-otp-error {
    border-color: #D92D20 !important;
  }
  .redacto-assisted-link {
    background: none !important;
    border: none !important;
    padding: 0 !important;
    cursor: pointer !important;
    font: inherit !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 4px !important;
  }
  .redacto-assisted-link:disabled {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  }
  button:disabled.redacto-assisted-primary-btn {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  }
  @keyframes redactoAssistedReveal {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .redacto-assisted-reveal {
    animation: redactoAssistedReveal 0.2s ease-out;
  }
  @media (prefers-reduced-motion: reduce) {
    .redacto-assisted-reveal { animation: none; }
  }
`;

export const injectAssistedStyles = (root: ShadowRoot): void => {
  if (root.querySelector(`#${ASSISTED_STYLE_ID}`)) return;
  const style = document.createElement("style");
  style.id = ASSISTED_STYLE_ID;
  style.textContent = ASSISTED_CSS;
  root.appendChild(style);
};

export const assistedStyles = {
  lockedOptions: {
    opacity: "0.6",
    pointerEvents: "none",
  },
  verifyPanel: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    border: "1px solid #EAECF0",
    borderRadius: "12px",
    padding: "16px",
    backgroundColor: "#FCFCFD",
    boxSizing: "border-box",
  },
  verifyPanelHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  },
  verifyPanelTitle: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "15px",
    fontWeight: 600,
    color: "#101828",
  },
  fieldLabelRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  },
  fieldLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "13px",
    fontWeight: 500,
    color: "#475467",
  },
  phoneField: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    border: "1px solid #d0d5dd",
    borderRadius: "8px",
    padding: "10px 12px",
    backgroundColor: "#ffffff",
    boxSizing: "border-box",
  },
  phonePrefix: {
    fontSize: "15px",
    color: "#475467",
    fontWeight: 500,
  },
  helperText: {
    margin: 0,
    fontSize: "12px",
    color: "#667085",
  },
  otpStatusRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  otpSentText: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "13px",
    color: "#344054",
  },
  fieldError: {
    margin: 0,
    fontSize: "13px",
    color: "#D92D20",
  },
  centerLabel: {
    margin: 0,
    fontSize: "13px",
    color: "#475467",
    textAlign: "center",
  },
  otpRow: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
  },
  resendText: {
    margin: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    fontSize: "13px",
    color: "#667085",
  },
  errorTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: 600,
    color: "#101828",
  },
  errorText: {
    margin: 0,
    fontSize: "14px",
    color: "#475467",
  },
  declineSpacer: {
    marginRight: "auto",
  },
  rowButton: {
    width: "auto",
  },
  stackButton: {
    width: "100%",
  },
} as const;
